import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-olps-charge-time',
    templateUrl: './olps-charge-time.component.html',
    styleUrls: ['./olps-charge-time.component.scss',
        './../card.scss'],
    standalone: false
})
export class OlpsChargeTimeComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Capacitor: PropertySet;

    charge: Property<any>;

    constructor()
    {
        super('olps-charge-time');
        this.chart = true;
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Capacitor == null)
        {
            this.charge = null;
        }
        else
        {
            this.charge = this.Capacitor.properties.get('CHARGE_LEVEL');
        }
    }

}
